import React from 'react';
import { styled } from 'dripsy';
import { observer } from 'mobx-react-lite';
import { View } from 'react-native';
import { useTranslation } from 'react-i18next';

import { BaseText } from '@components';
import { Tutorial } from '@models/Tutorials/TutorialModel';
import { IS_WEB } from '@utils';

const Container = styled(View)({
  flexDirection: 'row',
});

const Text = styled(BaseText)({
  color: '$text400',
  variant: IS_WEB ? 'text.medium' : 'text.xsmall',
});

const VerticalLine = styled(View)({
  height: '100%',
  bg: '$text60',
  width: 1,
  mx: '$4',
});

export interface IViewsInfoProps {
  tutorial: Tutorial;
}

export const ViewsInfo = observer<IViewsInfoProps>(({ tutorial }) => {
  const { t } = useTranslation();

  const viewsText = t('tutorial.view', {
    count: tutorial.views,
  });

  return (
    <Container>
      <Text>{viewsText}</Text>
      <VerticalLine />
      <Text>{tutorial.formattedUploadDateTexted}</Text>
    </Container>
  );
});
